import type { AnchorHTMLAttributes, ButtonHTMLAttributes, HTMLAttributes, ReactNode, Ref } from 'react'
import styles from './list.module.css'
import { cx } from './cx'

/** Белая карточка со строками и разделителями `line`. */
export function List({ heading, children, className }: { heading?: string; children: ReactNode; className?: string }) {
  return (
    <div className={cx(styles.list, className)}>
      {heading !== undefined && <span className={styles.heading}>{heading}</span>}
      {children}
    </div>
  )
}

interface RowExtra {
  value?: ReactNode
  danger?: boolean
}

export function ListRow({
  value,
  danger = false,
  className,
  children,
  ...rest
}: HTMLAttributes<HTMLDivElement> & RowExtra) {
  return (
    <div className={cx(styles.row, danger && styles.danger, className)} {...rest}>
      <span>{children}</span>
      {value !== undefined && <span className={styles.value}>{value}</span>}
    </div>
  )
}

export function ListRowButton({
  value,
  danger = false,
  className,
  children,
  type = 'button',
  ...rest
}: ButtonHTMLAttributes<HTMLButtonElement> & RowExtra) {
  return (
    <button type={type} className={cx(styles.row, danger && styles.danger, className)} {...rest}>
      <span>{children}</span>
      {value !== undefined && <span className={styles.value}>{value}</span>}
    </button>
  )
}

export function ListRowLink({
  value,
  danger = false,
  className,
  children,
  ...rest
}: AnchorHTMLAttributes<HTMLAnchorElement> & RowExtra & { ref?: Ref<HTMLAnchorElement> }) {
  return (
    <a className={cx(styles.row, danger && styles.danger, className)} {...rest}>
      <span>{children}</span>
      {value !== undefined && <span className={styles.value}>{value}</span>}
    </a>
  )
}
